import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { renderPasswordField, renderTextField} from './reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from './buttons';
import validate from './validateChangePassword';
import { changePassword } from '../components/changePassword/actions/changePasswordAction';

class changePasswordModal extends Component {
  constructor(props) {
   super(props);
    this.state = {
      open: true,
      showUpdatePasswordModal: false,
      userID: this.props.loginUserInfo.userID,
    };
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      };
    };
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    };
  };

  onSubmitHandler(formData) {
    formData.userID = this.state.userID;
    this.props.changePassword(formData)
    this.handleClose();
  };

 render() {
 
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Update Password" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <div style={{width:"100%", display:"flex", justifyContent:"flex-start"}}>

        <CancelButton className="mr-15" onTouchTap={this.handleClose} />
        {submitButton}
      </div>
    ];
    return (
      <div>
        <Dialog className="custom_modal"
        title='Change password'
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>
        <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form" style={{display:"flex"}} onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
                <div className="col-sm-6 col-md-6">
                  <div className="col-sm-12 col-md-12 require">
                    <Field
                      name="currentPassword"
                      type="password"
                      maxLength="20"
                      minLength="6"
                      label="Current Password"
                      component={renderTextField}
                    />
                  </div>
                  <div className="col-sm-12 col-md-12 require">
                    <Field
                      name="newPassword"
                      label="New Password"
                      type="password"
                      maxLength="20"
                      minLength="6"
                      component={renderTextField}
                    />
                  </div>
                  <div className="col-sm-6 col-md-12 require">
                    <Field
                      name="confirmNewPassword"
                      maxLength="20"
                      type="password"
                      minLength="6"
                      label="Confirm New Password"
                      component={renderTextField}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 mt-3 lineheader">
                  <p className="pl-3">Password Criteria</p>
                    <ul>
                      <li>Minimum 8 and maximum 30 characters</li>
                      <li>Atleast 1 lowercase character</li>
                      <li>Atleast 1 uppercase character</li>
                      <li>Atleast 1 number</li>
                      <li>Atleast 1 special character</li>
                      <li>New password cannot be the same as current password</li>
                    </ul>
                </div>
              </form>
            </div>
        </div> 
      </Dialog>
      </div>
      
    );
  };
};

function mapStateToProps(state) {
  return {
    loginUserInfo: state.login.loginUserInfo,
    fieldError: state.appConfig.fieldError,
  };
};

changePasswordModal = reduxForm({
  form: 'changePasswordModalForm',
  validate,
  enableReinitialize: true,
})(changePasswordModal);

export default connect(mapStateToProps, { changePassword })(changePasswordModal);



// WEBPACK FOOTER //
// ./src/components/changePasswordModal.js